export default __webpack_public_path__ + "static/media/error-triangle.fe561a7e.svg";